import { PLATFORM_REPORT_BRAND_LOADED } from "../actions/reportBrand.action";

const initialState = {
    brandData: null,
};

export default function reportBrandsReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) { 
        case PLATFORM_REPORT_BRAND_LOADED:
            return {
                ...state,
                brands: payload,
            };
        default:
            return state;
    }
}